import { Component, OnInit } from '@angular/core';
import { LoginService } from '../services/login.service';
import { Globals } from '../objects/Globals';
import { Router } from '@angular/router';
import { ThemeSettingService } from '../services/theme-setting.service';
import { WorkflowReturnService } from '../services/workflow-return.service';
import { MessagePopupService } from '../services/message-popup.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  isBusy: boolean = true;
  private loaderConfig:any;
  constructor(private loginService:LoginService, private globals:Globals, private router:Router, private themeSettingService: ThemeSettingService, 
    private workflowReturnService: WorkflowReturnService, private messagePopupService: MessagePopupService) { }

  ngOnInit() {
    this.loaderConfig = this.themeSettingService.getTheme();
    
    this.isBusy = true;
    if(this.globals.Session){
      this.loginService.getHomePage().subscribe(result=>{
        this.isBusy = false;
        var command = JSON.parse(result);
        this.workflowReturnService.handleWorkflowReturn(command, true, true);
      });
    }else{
      this.isBusy = false;
      this.router.navigate(['/', 'login']);
    }
  }

}
